import useApiController from "@hooks/useApiController";
import useStatic from "@hooks/useStatic";

export default function usePromoController(salonId: string | number) {
    const { index, store, show, update, destroy } = useApiController<Resources.ClubPromo>(`/api/club/admin/salons/${salonId}/clubpromos`)

    return useStatic({ index, store, show, update, destroy })
}